import { useEffect } from 'react';
import type { DashboardSettings } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useDashboardSettings() {
  const dashboardSettings = useAxios(
    (axios, baseConfig) =>
      axios.request<DashboardSettings>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/shipperUsers/settings/dashboard`,
        method: 'GET',
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    dashboardSettings.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return dashboardSettings;
}

export type DashboardSettingsRequest = ReturnType<typeof useDashboardSettings>;
